import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ValidateCustomerPayload {
  accountVerificationType: string;
  verificationKey: string;
  verificationData: {
    [key: string]: string;
  };
}

export interface AccountVerificationInfo {
  accountVerificationType: string;
  verificationKey: string;
  additionalInfos: {
    additionalProp1: string;
    additionalProp2: string;
    additionalProp3: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class FirstLoginScaniaService {
  constructor(private readonly http: HttpClient) {}

  validateCustomer(payload: ValidateCustomerPayload): Observable<string> {
    return this.http.post(`/api/core/user/Verification/verify-account`, payload, { responseType: 'text' });
  }

  accountVerificationInfo(): Observable<AccountVerificationInfo> {
    return this.http.get<AccountVerificationInfo>(`/api/core/user/Verification/account-verification-info`);
  }
}
